module.exports = __webpack_public_path__ + "img/main_bg_05.ff3313fc.png";